import type { AxiosInstance } from 'axios';
import type {
	NahledyudajuPppOvmSeznamResponseDto,
	NahledyudajuPppPppDetailDto,
	NahledyudajuPppPppSeznamResponseDto,
	NahledyudajuPppPppTypyResponseDto,
	NahledyudajuPppVypisOvmProTypPppParams,
	NahledyudajuPppVypisSeznamPppParams,
	NahledyudajuPppVypisTypyPppParams,
} from '../generated';

export const fetchPPPSeznamQuery = async (
	axiosInstance: AxiosInstance,
	params: NahledyudajuPppVypisSeznamPppParams
): Promise<NahledyudajuPppPppSeznamResponseDto> => {
	const { data } = await axiosInstance.get<NahledyudajuPppPppSeznamResponseDto>(
		'/api/v1/ppp/zaznamy',
		{ params }
	);

	return data;
};

export const fetchPPPDetailQuery = async (
	axiosInstance: AxiosInstance,
	pppId: string
): Promise<NahledyudajuPppPppDetailDto> => {
	const { data } = await axiosInstance.get<NahledyudajuPppPppDetailDto>(
		`/api/v1/ppp/zaznamy/${pppId}`
	);

	return data;
};

export const fetchPPPTypesQuery = async (
	axiosInstance: AxiosInstance,
	params?: NahledyudajuPppVypisTypyPppParams
): Promise<NahledyudajuPppPppTypyResponseDto> => {
	const { data } = await axiosInstance.get<NahledyudajuPppPppTypyResponseDto>(
		'/api/v1/ppp/typy',
		{ params }
	);

	return data;
};

export const fetchPPPTypesOvmQuery = async (
	axiosInstance: AxiosInstance,
	params: NahledyudajuPppVypisOvmProTypPppParams
): Promise<NahledyudajuPppOvmSeznamResponseDto> => {
	const { typPppKod, ...restParams } = params;
	const { data } = await axiosInstance.get<NahledyudajuPppOvmSeznamResponseDto>(
		`/api/v1/ppp/typy/${typPppKod}/ovm`,
		{ params: restParams }
	);

	return data;
};
